import { useEffect } from 'react'

import { STATUS } from 'helpers/spa'

const useHighlyViewedIntersect = (status, sendEvent) => {
  useEffect(() => {
    // has to check against status instead of listings, otherwise it will initialize before the component is rendered
    if (status !== STATUS.idle) {
      return
    }
    const listingElements = document.querySelectorAll('.ListingCard')

    const highlyViewedListings = []
    listingElements.forEach(node => {
      const item = node.querySelector('.HighlyViewedChip')
      if (item) {
        highlyViewedListings.push(node)
      }
    })

    if (!highlyViewedListings.length) {
      return
    }

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target)
          sendEvent({
            engagementComponent: 'product_card-item',
            engagementDestination: 'impression',
            engagementDetails: 'highly-viewed',
            name: 'engagement_impression',
            nonInteraction: true,
          })
        }
      })
    }

    let observer = new IntersectionObserver(observerCallback, { threshold: 0.3 })

    highlyViewedListings.forEach(item => {
      observer.observe(item)
    })

    return () => observer.disconnect()
  }, [status, sendEvent])
}

export default useHighlyViewedIntersect
